import { Button, Flex } from '@components';
import { Cancel } from '@mui/icons-material';
import { Box, styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  height: '100%',
  maxHeight: '100%',
  overflowY: 'auto',
  flexDirection: 'column',
  marginTop: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(20),
  },
}));

export const StyledHeaderContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
}));

export const TableContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  flex: 0,
  border: `1px solid ${theme.palette.grey[500]}`,
  borderRadius: theme.spacing(5),
}));

export const BackButton = styled(Button)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const BottomPanelButtonsContainer = styled(Flex)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  zIndex: 1000,
  flex: 1,
  justifyContent: 'space-between',
  padding: theme.spacing(8, 8),
  backgroundColor: theme.palette.common.white,
  boxShadow: '0px 4px 54px rgba(0, 0, 0, 0.25)',
  gap: theme.spacing(10),
}));

export const CancelIcon = styled(Cancel)(({ theme }) => ({
  color: theme.palette.grey.A100,
}));
